import React, { useEffect, useRef } from "react"
import { gsap } from "gsap"
import { Draggable } from "gsap/Draggable"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import "../styles/clients.scss";

const Clients = () => {
  const carouselRef = useRef(null)

  const data = useStaticQuery(graphql`
    query {
      client1: file(relativePath: { eq: "clients/client1.png" }) {
        childImageSharp {
          fixed(width: 85, height: 21, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      client2: file(relativePath: { eq: "clients/client2.png" }) {
        childImageSharp {
          fixed(width: 71, height: 29, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      client3: file(relativePath: { eq: "clients/client3.png" }) {
        childImageSharp {
          fixed(width: 28, height: 28, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      client4: file(relativePath: { eq: "clients/client4.png" }) {
        childImageSharp {
          fixed(width: 21, height: 21, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      client5: file(relativePath: { eq: "clients/client1.png" }) {
        childImageSharp {
          fixed(width: 85, height: 21, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      client6: file(relativePath: { eq: "clients/client2.png" }) {
        childImageSharp {
          fixed(width: 71, height: 29, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      client7: file(relativePath: { eq: "clients/client3.png" }) {
        childImageSharp {
          fixed(width: 28, height: 28, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      client8: file(relativePath: { eq: "clients/client4.png" }) {
        childImageSharp {
          fixed(width: 21, height: 21, fit: INSIDE) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  useEffect(() => {
    gsap.registerPlugin(Draggable)
    if (carouselRef.current) {
      Draggable.create(carouselRef.current, {
        type: "x",
        inertia:true,
        bounds: {
          minX: -carouselRef.current.clientWidth + window.innerWidth * 1,
          minY: 0,
          maxX: 0,
          maxY: 0,
        },
      })
    }
  }, [])

  return (
    <div className="hp-clients-container">
      <h2>Clients</h2>

      <div className="ClientsListContainer">
        <div className="ClientsList" ref={carouselRef}>
          {Object.keys(data).map(_name => (
            <div className="ClientItem" key={_name}>
              <Img fixed={data[_name].childImageSharp.fixed} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Clients